module.exports = __webpack_public_path__ + "img/i-miss-you.5a5236f.svg";